<template>
  <div v-if="zillowProfile || possibleMatches" class="mb-6">
    <card extra-classes="bg-white px-4 py-5 sm:px-6">
      <h2 class="text-lg font-medium text-gray-900">Zillow Profile</h2>
      <div v-if="!possibleMatches && zillowProfile">
        <a :href="zillowProfile.RevieweeProfileURL" target="_blank">
          <div class="mt-2 text-sm text-gray-900">
            {{ zillowProfile.RevieweeFullName }} - {{ zillowProfile.RevieweeBusinessName }}
          </div>
          <div class="mt-2 flex">
            <svg
              v-for="star in maxStarRating"
              :key="star"
              xmlns="http://www.w3.org/2000/svg"
              :fill="zillowProfile.AverageReviewRating >= star - 0.5 ? 'black' : 'none'"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
              />
            </svg>
            <div class="ml-2">({{ zillowProfile.ReviewCount }})</div>
          </div>
        </a>
      </div>
      <div v-else>
        <a
          v-for="(match, index) in visibleProfiles"
          :key="match.RevieweeKey"
          :href="match.RevieweeProfileURL"
          target="_blank"
        >
          <div class="mt-2 text-sm text-gray-900">{{ match.RevieweeFullName }} - {{ match.RevieweeBusinessName }}</div>
          <div class="mt-2 flex">
            <svg
              v-for="star in maxStarRating"
              :key="star"
              xmlns="http://www.w3.org/2000/svg"
              :fill="match.AverageReviewRating >= star - 0.5 ? 'black' : 'none'"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
              />
            </svg>
            <div class="ml-2">({{ match.ReviewCount }})</div>
          </div>
        </a>
        <div
          v-if="zillowProfiles.length > visibleProfiles.length"
          class="mt-2 cursor-pointer text-indigo-600 hover:text-indigo-900 text-center text-sm"
          @click="onShowMore"
        >
          View more
        </div>
      </div>
    </card>
  </div>
</template>

<script setup>
import Card from '../Card/index.vue';
import useZillowProfile from '../../composables/useZillowProfile';

// The maximum number of stars to display in the rating
const maxStarRating = 5;

const props = defineProps({
  contact: Object,
});

const { zillowProfile, zillowProfiles, possibleMatches, visibleProfiles, showMoreProfiles } = useZillowProfile(
  props.contact
);

function onShowMore() {
  showMoreProfiles();
}
</script>
